import { Component, OnInit } from '@angular/core';
import 'hammerjs';


@Component({
  selector: 'special-form',
  templateUrl: './special-form.component.html',
  styleUrls: ['./special-form.component.scss']
})
export class SpecialFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
